import { articles } from '@/mocks/comic';

export default function Analysis() {
  return (
    <section id="analysis" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
            <span className="h-px w-8 bg-primary-500" />
            深度专题
            <span className="h-px w-8 bg-primary-500" />
          </span>
          <h2 className="mt-4 font-heading text-3xl font-black text-foreground-900 md:text-4xl">
            剧情解析专题文章
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-base text-foreground-700">
            从伏笔、人物到结局预测，把每一个值得留意的细节讲给你听。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-7 md:grid-cols-2 lg:grid-cols-3">
          {articles.map((a) => (
            <article
              key={a.id}
              className="group flex flex-col overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200/70 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={a.image}
                  alt={`${a.title}专题配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                  {a.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-900 group-hover:text-primary-700">
                  {a.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{a.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/80 pt-3 text-xs text-foreground-500">
                  <span>{a.date}</span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {a.read}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}